import React from 'react'

export default function Loader() {
  return (
    <div>

        <span className="loading loading-spinner loading-lg text-secondary"></span>
        <br />
        <p>Loading...</p>
        </div>
  )
}
